var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"exam-uniform-student-score-exam-input",class:{'is-pass': _vm.isScorePass, 'is-fail': _vm.isScoreFail}},[(_vm.cellValue)?[_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.valueText))])]:[_c('span',{staticClass:"not-join"})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }